import { sourceFromDataset, trackSelectItem } from "../../helpers/dataLayer";

// dl_select_item for a link out of a product card, except on collection
// templates, or out of a style product card, anywhere.
document.addEventListener("click", (e) => {
  const link = e.target.closest("a[href]");
  const card = link?.closest("[data-product-card][data-dl-product-id]");
  if (!card) return;

  if (card.matches("product-card") && window.theme.template === "collection") {
    return;
  }

  const list = card.closest(".shopify-section") || document;
  const position =
    [...list.querySelectorAll("[data-product-card]")].indexOf(card) + 1;

  trackSelectItem(sourceFromDataset(card.dataset), position);
});
